import { RevenueCard } from "./components/revenueCard";
import styles from "./styles.module.scss";
import {
  AverageRevenueIcon,
  ForcastedRevenueIcon,
  GrowthIcon,
  ExpectedIncomeIcon,
} from "../../icons";
import { Spin } from "antd";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";

const platformKeys = {
  iOS: "iOS",
  android: "android",
  web: "web",
  desktop: "studio",
};

export const RevenueCards = ({ height, activePlateform }) => {
  const { data: revenueData, isLoading: revenueLoading } =
    UseApiCallForOldDashboardData({
      url: "get_payments",
      method: "POST",
      body: {
        data: "none",
      },
    });

  const { data: growthRevenue, isLoading: growthRevenueLoading } =
    UseApiCallForOldDashboardData({
      url: "growth_revenue",
      method: "POST",
      body: {
        data: "none",
      },
    });

  const currentPlatform = platformKeys[activePlateform];

  const averageRevenue = revenueData?.[currentPlatform]?.average;
  const forcastedRevenue = revenueData?.[currentPlatform]?.forecasted;
  const growth = growthRevenue?.[currentPlatform]?.growth;
  const loading = revenueLoading || growthRevenueLoading;

  const revenueCardsData = [
    {
      title: "Average Revenue",
      value: averageRevenue?.toFixed(0) || 0,
      Icon: AverageRevenueIcon,
      bgColor: "#86CDFF",
      currency: "€",
    },
    {
      title: "Forecasted Revenue",
      value: forcastedRevenue?.toFixed(0) || 0,
      Icon: ForcastedRevenueIcon,
      bgColor: "#FBB900",
      currency: "€",
    },
    {
      title: "Growth",
      value: `${growth?.toFixed(2) ?? 0}%`,
      Icon: GrowthIcon,
      bgColor: "#94C800",
      currency: "",
    },
    {
      title: "Expected Income",
      value: "78,500K",
      Icon: ExpectedIncomeIcon,
      bgColor: "#C4C4C4",
      currency: "€",
    },
  ];

  return (
    <Spin spinning={loading}>
      <div className={styles.revenueCards} style={{ height: height + "px" }}>
        {revenueCardsData?.map((singleCard) => (
          <RevenueCard key={singleCard.title} data={singleCard} />
        ))}
      </div>
    </Spin>
  );
};
